<template>
    <div>
        <b-modal
            :id="modalId"
            modal-class="modal-confirm-redeem"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="confirm_modal_image">
                        <img :src="campaign.fullImageUrl" alt="">
                    </div>
                </div>
                <div class="modal-base-body">
                    <p id="confirm_modal_title" class="modal-head-txt" v-html="lblConfirmRedeem.headline"></p>
                    <p id="confirm_modal_msg" class="modal-body-txt"
                    v-html="`${lblConfirmRedeem.pre_msg}  ${pointTypeMsg} ${campaignPoint} ${lbl.detail.point} ${msg}`"></p>
                </div>
                <div class="modal-base-footer modal-footer-btn-row">
                    <div class="btn-wrapper btn-cancel" @click="clickCancel()"> 
                        <div class="btn-txt"> {{lblConfirmRedeem.cancel}}</div>  
                    </div>
                    <div class="btn-wrapper" @click="clickConfirm()">
                        <div class="btn-txt">{{lblConfirmRedeem.confirm}}</div>      
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from "vue";
import Moment from "moment";
//helper
import Util from "@/helper/Utility.js";
import Locale from "@/helper/locale/locale.js";
import { TrackingService } from "@/helper/TrackingHelper.js";

export default {
    name: 'ConfirmRedeemModal',
    props: {
        controller: Object,
        modalId: String,
        theme: String
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            lblConfirmRedeem: {},
            lblDate: {},
            localeCode: Locale.getLocaleCode(),

            campaign: {},
            msg: '',
            tag: '',
            campaignPoint: 0,

            busModal: null,
            trackingService: new TrackingService(this),
            pointTypeMsg: ''
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.lblConfirmRedeem = this.lbl.confirm_redeem;
        this.lblDate = this.lbl.date;

        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //Event
        clickConfirm: function () {
            var trackingEventCategory = 'campaigndetail_page'
            var eventName = 'click_redeem_submit'
            this.trackingService.event(trackingEventCategory, eventName, null, null)
            
            this.hide();
            this.controller.sendCallbackConfirm({tag: this.tag});
        },
        clickCancel: function () {
            this.hide();
            this.controller.sendCallbackCancel({tag: this.tag});
        },
        //modal
        show: function (config) {
            this.campaign = config.campaign;
            this.msg = this.campaign.name;
            this.campaignPoint = this.campaign.pointPerUnit;
            this.tag = config.tag;
            this.pointTypeMsg = this.campaign.pointType === 'get' ? this.lbl.detail.get_point : this.lbl.detail.use_point;
            this.initialModal();

            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        },
        //Method
        initialModal: function () {
            var minute = this.campaign.minutesValidAfterUsed;
            var isDelivered = false;
            var haveTimer = false;

            if(this.campaign.delivered) isDelivered = true;
            if(this.campaign.minutesValidAfterUsed
                || this.campaign.minutesValidAfterUsed > 0) haveTimer = true;

            this.headline = this.lblConfirmRedeem.headline;
            switch(this.campaign.type) {
                case Vue.CampaignType.Draw:
                    this.message = isDelivered
                        ? this.lblConfirmRedeem.draw_delivery
                        : this.getDrawMessage(this.lblConfirmRedeem.draw);
                    break;
                case Vue.CampaignType.Free:
                    if(isDelivered) {
                        this.message = this.lblConfirmRedeem.free_delivery;
                    } else {
                        this.message = haveTimer
                            ? this.getTimerMessage(this.lblConfirmRedeem.free, minute)
                            : this.lblConfirmRedeem.free_no_timer;
                    }
                    break;
                case Vue.CampaignType.Deal:
                    if(isDelivered) {
                        this.message = this.lblConfirmRedeem.deal_delivery;
                    } else {
                        this.message = haveTimer
                            ? this.getTimerMessage(this.lblConfirmRedeem.free, minute)
                            : this.lblConfirmRedeem.deal_no_timer;
                    }
                    break;
                case Vue.CampaignType.Buy:
                    this.message = this.lblConfirmRedeem.buy;
                    break;
                case Vue.CampaignType.Interface:
                    this.message = this.lblConfirmRedeem.interface;
                    break;
                default:
                    break;
            }
        },
        //Utilities
        getTimerMessage: function (message, minutes) {
            var result = '';
            var days = '';
            var hours = '';
            var minuteAfterUsed = minutes;
            if (minuteAfterUsed >= 60) {
                hours = Math.floor(minuteAfterUsed / 60);
                if (hours >= 24) days = Math.floor(hours / 24);
            }

            if (days) result += days + ' ' + this.lblDate.days + ' ';
            if (hours) result += hours + ' ' + this.lblDate.hours + ' ';
            if (minutes / 60 > 0) result += (minutes % 60) + ' ' + this.lblDate.minutes_short;

            return Util.stringFormat(message, result);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        }
    }
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    .modal-confirm-redeem {
        @extend %modal-base;

        .modal-dialog {
            max-width: 360px;
        }

        .modal-base-head {
            margin-bottom: 20px;
            
            .confirm_modal_image {
                @include baseCampaignImg(66.67%);
                border-radius: 10px;
                width: 170px;
                margin-top: -70px;
                margin-left: auto;
                margin-right: auto;
            }
          
        }

        .modal-base-body {
            #confirm_modal_title {
                color: $green-00987F;
            }

            #confirm_modal_msg {
                padding-bottom: 16px;
                font-size: 1.5rem;
                font-family: $regular;
                color: $a-gray-575757;
                line-height: normal;
            }
        }
    }

</style>
